export const isEqualCaseSensitive = (a: string, b: string) => {
  return a.trim() === b.trim();
};

export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
